import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AirportAlert } from '../models/airport-alert.model';


@Injectable()
export class AlertService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * updates specified entity via api
   * @param {number} airportID
   * @param {AirportAlert} alert
   * @return {Promise<any>}
   */
  putAirportAlert(airportID: number, alert: AirportAlert): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/alert/${alert.alertId}`;
    try {
      const BODY = this._getFuelJSON(alert);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * adds specified entity via api
   * @param {number} airportID
   * @param {AirportAlert} alert
   * @return {Promise<any>}
   */
  postAirportAlert(airportID: number, alert: AirportAlert): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/alert/`;
    try {
      const BODY = this._getFuelJSON(alert);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * deletes specified entity via api
   * @param {number} airportID
   * @param {number} alertID
   * @return {Promise<any>}
   */
  deleteAirportAlert(airportID: number, alertID: number): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/alert/${alertID}`;
    try {
      return this._http.delete(URL).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts entity to json obj
   * @param {AirportAlert} alert
   * @return {any}
   * @private
   */
  _getFuelJSON (alert: AirportAlert): any {
    return {
      code: 'AFM',
      priority: AirportAlert.formatAlertPriority(alert.priority).toLowerCase(),
      title: alert.title,
      description: alert.description,
      website: alert.website,
      effectiveDate: alert.effectiveDate,
      expirationDate: alert.expirationDate
    };
  }
}
